import { useState, useContext } from 'react';
import { UserContext } from '../context/UserContext';
import { Menu } from '@headlessui/react';
import { HiDotsHorizontal } from "react-icons/hi";
import { DeleteAccess } from './dialogs/deleteAccess';
import { ChangeAccess } from './dialogs/changeAccess';
import { LuTrash } from 'react-icons/lu';
import { BsPencil } from "react-icons/bs";

export const UserManagementMenu = ({associate, getAssociates, associates, userView}) => {
  const { user } = useContext(UserContext);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openChangePermission, setOpenChangePermission] = useState(false);

  const isLastAdmin = associate?.permission === 'admin' && associates?.filter((a) => a.permission === 'admin').length === 1;
  const isOwnUser = associate?.entity_id === user.id;

  return (
    <Menu as="div" className="relative text-sm inline-block text-left">
      <DeleteAccess openDeleteModal={openDeleteModal} setOpenDeleteModal={setOpenDeleteModal} associate={associate} getAssociates={getAssociates} associates={associates}/>
      <ChangeAccess openChangePermission={openChangePermission} setOpenChangePermission={setOpenChangePermission} associate={associate} getAssociates={getAssociates} associates={associates}/>
      <div>
        <Menu.Button className="inline-flex w-full items-center justify-center rounded-md overflow-hidden px-3 py-2 text-sm text-gray-600 justify-items-center hover:bg-gray-50">
          <HiDotsHorizontal className={"h-5 w-5"} />
        </Menu.Button>
      </div>

      <Menu.Items
        transition="true"
        className="absolute right-0 overflow-hidden z-10 mt-2 w-56  origin-top-right divide-y divide-gray-500 rounded-md bg-white shadow-lg ring-1 ring-gray-500 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
      >
        {!userView &&
          <div>
            <Menu.Item>
                <button 
                  className={`flex p-2 hover:bg-gray-900 hover:text-white w-full cursor-pointer disabled:hover:bg-white disabled:hover:text-gray-550 disabled:text-gray-550 disabled:hover:cursor-default`} 
                  onClick={() => setOpenChangePermission(true)}
                  disabled={isOwnUser && isLastAdmin}
                >
                  <BsPencil title='Zugriff ändern' className="w-8 h-8 p-2" />
                  <span className="h-8 p-2">Zugriff ändern</span>
                </button>
            </Menu.Item>
          </div>
        }
        <div>
          <Menu.Item>
              <button 
                className={`flex p-2 disabled:hover:bg-white hover:text-white disabled:hover:text-gray-550 disabled:text-gray-550 text-red cursor-pointer disabled:hover:cursor-default hover:bg-red w-full`} 
                onClick={() => setOpenDeleteModal(true)}
                disabled={isLastAdmin}
              >
                <LuTrash title='Zugriff entfernen' className="w-8 h-8 p-2" />
                <span className="h-8 p-2">Endgültig entfernen</span>
              </button>
          </Menu.Item>
        </div>
      </Menu.Items>
    </Menu>
  );
}
